@if (view === 'confirmacao') {
  <div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon"><mat-icon class="material-symbols-outlined">file_download</mat-icon></div>
    <div class="modal-header-titles">
      <h2 class="modal-title">Confirmação de extração</h2>
      <span class="modal-subtitle">Revise os filtros antes de solicitar o arquivo.</span>
    </div>
    <div class="modal-header-close-btn-container">
      <button
        mat-icon-button
        type="button"
        class="modal-close-btn icon-mat-symbols-btn"
        (click)="fechar()"
        [disabled]="_isLoadingConfirmacao"
        aria-label="Fechar">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content class="modal-content">
    <p class="dialog-instruction">
      Você deseja solicitar a extração de: <strong>{{ data.titulo }}</strong> utilizando os filtros abaixo?
    </p>
    <div class="filtros-container">
      @for (filtro of data.filtros; track filtro.formControlName) {
        <div class="filtro-linha">
          <span class="filtro-label">{{ filtro.label }}</span>
          <div class="filtro-conteudo">
            @for (item of valoresExibicao(filtro); track item) {
              <span class="chip-valor" [title]="item">{{ item }}</span>
            }
          </div>
        </div>
      }
      @if (data.filtros.length === 0) {
        <div class="empty-state">
          <mat-icon>filter_alt_off</mat-icon
          ><span>Nenhum filtro aplicado. A extração considerará todos os dados.</span>
        </div>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="modal-footer">
    @if (data.possuiAutomacao) {
      <button
        mat-button
        class="btn-secondary btn-automacao"
        type="button"
        (click)="visualizarAutomacoes()"
        [disabled]="_isLoadingConfirmacao">
        <mat-icon>bolt</mat-icon><span>Ir para automações de extração</span><mat-icon>chevron_right</mat-icon>
      </button>
    }
    <button mat-stroked-button class="btn-secondary" (click)="fechar()" [disabled]="_isLoadingConfirmacao">
      Cancelar
    </button>
    <button
      mat-flat-button
      class="btn-primary"
      (click)="confirmarExtracao()"
      [disabled]="_isLoadingConfirmacao">
      @if (_isLoadingConfirmacao) {
        <mat-spinner diameter="20"></mat-spinner>
      } @else {
        <span>Confirmar</span>
      }
    </button>
  </mat-dialog-actions>
} @else {
  <div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon"><mat-icon class="material-symbols-outlined">smart_toy</mat-icon></div>
    <div class="modal-header-titles">
      <h2 class="modal-title">Processando sua solicitação</h2>
      <span class="modal-subtitle">{{ data.titulo }}</span>
    </div>
    <div class="modal-header-close-btn-container">
      <button
        mat-icon-button
        type="button"
        class="modal-close-btn icon-mat-symbols-btn"
        (click)="fechar()"
        aria-label="Fechar">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content class="modal-content acompanhamento-content">
    <p>
      Seu pedido de download de <strong>{{ data.titulo }}</strong> foi criado com sucesso!
    </p>
    @if (statusFinal === null) {
      <p>
        Não se preocupe! Nossos robôs já estão trabalhando para preparar seus arquivos. Você pode fechar esta
        janela ou aguardar aqui mesmo.
      </p>
    }
    <p>
      Quando o processo for finalizado,
      <strong
        >você receberá os arquivos por e-mail e será notificado no sininho
        <span class="material-symbols-outlined">notifications</span></strong
      >
    </p>
    <div class="status-container">
      @if (statusFinal === null) {
        <img src="assets/gifs/processando.gif" alt="Robô trabalhando" class="robo-gif" />
      }
      @if (statusFinal === 'sucesso') {
        <div class="status-final-wrapper">
          <mat-icon class="status-icon-done">check_circle</mat-icon>
          <h3>Processamento Concluído!</h3>
          <a [href]="linkDownload" target="_blank" class="link-download"
            >Clique aqui para baixar seu arquivo</a
          >
        </div>
      }
      @if (statusFinal === 'semDados') {
        <div class="status-final-wrapper">
          <mat-icon class="status-icon-empty">search_off</mat-icon>
          <h3 class="titulo-vazio">Nenhum dado encontrado</h3>
          <p class="mensagem-vazia">{{ mensagemSemDados }}</p>
        </div>
      }
      @if (statusFinal === 'erro') {
        <div class="status-final-wrapper">
          <mat-icon class="status-icon-error">report_problem</mat-icon>
          <p class="mensagem-erro">{{ mensagemErro }}</p>
        </div>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="modal-footer"
    ><button mat-flat-button class="btn-primary" (click)="fechar()">Fechar</button></mat-dialog-actions
  >
}
